import { useAuth0 } from "@auth0/auth0-react";
import Dialog from "@material-ui/core/Dialog";
import { withStyles } from "@material-ui/core/styles";
import Pagination from "@material-ui/lab/Pagination";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Loader from "components/loader/Loader";
import NotAuthorized from "components/NotAuthorized";
import EmailEditor from "components/SendLetter/EmailEditor/EmailEditor";
import FinanceSetting from "Lib/API/FinanceSetting/FinanceSetting";
import MemberService from "Lib/API/Member/index";
import { formatDate } from "helper/dateFormat";
import React, { useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import { useParams } from "react-router-dom";
import { NameWrapper, Title } from "./Theme";
import { fontConfig } from "theme/fontConfig";

export const Communication = () => {
  const headerTitles = [
    "RECIPIENT NAME",
    "CAMPAIGN NAME / AUTOMATION NAME",
    "SENT",
    "OPENED",
    "TEMPLATE",
  ];
  const [page, setPage] = useState(0);
  const [count, setCount] = useState();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const { getAccessTokenSilently } = useAuth0();
  const { id } = useParams();
  const [viewTemplateDialog, setViewTemplateDialog] = useState(false);
  const [templateData, setTemplateData] = useState({});
  const [tokenList, setTokenList] = useState([]);
  const [jsonContent, setJsonContent] = useState({});
  const [htmlContent, setHtmlContent] = useState("");
  const [isCommunicationActive, setIsCommunicationActive] = useState(false);

  let orgInfo = localStorage?.getItem("organization")
  ? JSON.parse(localStorage?.getItem("organization"))
  : [];

  let authorizedModulesInfo = localStorage?.getItem("authorizedModules")
  ? JSON.parse(localStorage?.getItem("authorizedModules"))
  : [];



  const tokenTypes = {
    yehrzeit: "deceased",
    event: "event",
    form: "form",
    education: "education",
    donation: "donation",
  };
  const TableCellHead = withStyles((theme) => ({
    root: {
      height: "39px",
      padding: "0px 20px",
      borderBottom: "none",
      fontFamily: fontConfig.GeneralTableCellHeadFont.family,
      background: "#f3f6f9",
    },
  }))(TableCell);

  const TableCellBody = withStyles((theme) => ({
    root: {
      height: "65px",
      padding: "0px 20px",
      fontFamily: fontConfig.GeneralTableCellBodyFont.family,
      fontSize: "14px",
      color: "#4D5565"
    },
  }))(TableCell);


  useEffect(() => {
    const status =
      orgInfo?.authorizedModules?.find(
        (item) => item?.moduleName === "communication"
      )?.active === true &&
      authorizedModulesInfo?.find((item) => item?.moduleName === "communication")
        ?.active === true
        ? true
        : false;

        setIsCommunicationActive(status);
  }, []);

  const getCommunicationList = async () => {
    setLoading(true);
    const data = {
      accountId: id,
    };
    try {
      const token = await getAccessTokenSilently();
      const result = await MemberService.getCommunicationMmber(
        data,
        token,
        page + 1,
        30
      );
      setRows(result?.payload?.data);
      setCount(result?.payload?.pagination?.count);
    } catch (err) {
      toastr.error("Error", err?.data?.message || "There something went wrong");
    } finally {
      setLoading(false);
    }
  };
  const getTemplateTokens = async (type) => {
    const fileType = tokenTypes[type] || "document";
    const token = await getAccessTokenSilently();
    try {
      const response = await FinanceSetting.getTemplateTokens(token, fileType);
      const tokens = response?.result;
      setTokenList(tokens);
    } catch (error) {
      toastr.error("Error", error?.data?.message ?? "Something went wrong");
    }
  };

  useEffect(() => {
    getCommunicationList();
   
  }, [page]);


  const displayCampaignNameOrAutomationName = (row) => {
    let name = "";
    if(row?.automationEventId) {
      name = row?.automation?.automationName;
    }
    if(row?.campaignId) {
      name = row?.campaign?.campaignName;
    }

    return name || row?.type || "-";
  }



  return isCommunicationActive == false ? (
    <NotAuthorized title={"Communications"} />
  ) : (
    <div
      className="w-100 school_class_list"
   
    >
      <div className={"family-table-container"}>
        <div className="current-class-table-container">
          <Title>Communication History</Title>
          <div style={{ paddingLeft: "17px", paddingRight: "17px" }}>
            <TableContainer className="scroll-table">
              <Table aria-label="collapsible table">
                <TableHead className="charges-table sticky-table-header">
                  {headerTitles.map((item) => (
                    <TableCellHead className="class__header__cell className_head">
                      {item}
                    </TableCellHead>
                  ))}
                </TableHead>
                <TableBody
                  style={{
                    backgroundColor: "white",
                  }}
                >
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={10} align="center">
                        <div
                          className="user__loader"
                          style={{ height: "320px" }}
                        >
                          <Loader />
                        </div>
                      </TableCell>
                    </TableRow>
                  ) : rows?.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={10} align="center">
                        <h6 style={{ height: "320px", marginTop: "100px" }}>
                          No Events Found
                        </h6>
                      </TableCell>
                    </TableRow>
                  ) : (
                    rows?.map((row, i) => (
                      <React.Fragment>
                        <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
                          <TableCellBody
                            className="main-width-class"
                            align="left"
                          >
                            <NameWrapper>
                              <Stack direction="row" spacing={2}>
                                <Avatar
                                  alt="Remy Sharp"
                                  src={row?.contact?.profile_img}
                                />
                              </Stack>
                              <span>{`${row?.contact?.first_name} ${row?.contact?.last_name}`}</span>
                            </NameWrapper>
                          </TableCellBody>
                          <TableCellBody
                            className="status-head main-width-class"
                            component="th"
                            scope="row"
                          >
                            <NameWrapper>
                              <span>{displayCampaignNameOrAutomationName(row)}</span>
                            </NameWrapper>
                          </TableCellBody>
                          <TableCellBody
                            className="main-width-class"
                            align="left"
                          >
                            {row?.createdAt
                              ? formatDate({
                                  date: row?.createdAt,
                                  formatType: "defaultWithTime",
                                })
                              : "-"}
                          </TableCellBody>
                          <TableCellBody
                            className="account-header main-width-class"
                            align="left"
                          >
                            {row?.opened
                              ? formatDate({
                                  date: row?.opened,
                                  formatType: "defaultWithTime",
                                })
                              : "-"}
                          </TableCellBody>
                          <TableCellBody
                            className="charged-head main-width-class"
                            align="left"
                            onClick={() => {
                              setViewTemplateDialog(true);
                              setTemplateData(row?.template);
                              getTemplateTokens(row?.template?.type);
                            }}
                          >
                            <div className="transaction-status">
                              <div style={{ width: 22 }}></div>
                              <div className="pl-0">
                                <div className="school-table-class-name">
                                  {row?.template?.title}
                                </div>
                              </div>
                            </div>
                          </TableCellBody>
                        </TableRow>
                      </React.Fragment>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            {rows?.length > 0 && (
              <div className="pagination-custom mt-9">
                <Pagination
                  count={Math.ceil(count / 30)}
                  color="primary"
                  variant="outlined"
                  page={page + 1}
                  onChange={(event, value) => {
                    setPage(value - 1);
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </div>

      <Dialog
        open={viewTemplateDialog}
        onClose={() => {
          setViewTemplateDialog(false);
        }}
        PaperProps={{
          style: {
            width: "1200px",
            height: "700px",
            overflow: "hidden",
            borderRadius: "22px",
            maxWidth: "1200px",
          },
        }}
        fullWidth
        maxWidth={"md"}
      >
        <EmailEditor
          closeModal={() => {
            setViewTemplateDialog(false);
          }}
          dropDownTypes={true}
          previewTemplete={true}
          setHtmlContentEdit={setHtmlContent}
          setJsonContentEdit={setJsonContent}
          jsonContentEdit={templateData?.jsonContent}
          htmlContentEdit={templateData?.htmlContent}
          enableEdit={false}
          tokenListEdit={tokenList}
          templateDetails={templateData}
        />
      </Dialog>
    </div>
  );
};
